import React, { useRef, useEffect } from 'react';

export const Reveal = ({ as: Tag = 'div', delay = 0, children, style, ...rest }) => {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      el.classList.add('is-in');
      return;
    }
    const io = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          el.classList.add('is-in');
          io.unobserve(el);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    io.observe(el);
    return () => io.disconnect();
  }, []);
  return (
    <Tag
      ref={ref}
      className={'reveal ' + (rest.className || '')}
      style={{ ...(style || {}), '--reveal-delay': `${delay}ms` }}
      {...rest}
    >
      {children}
    </Tag>
  );
};

export const RevealGroup = ({ children, step = 70, baseDelay = 0, style, ...rest }) => {
  const arr = React.Children.toArray(children);
  return (
    <div style={style} {...rest}>
      {arr.map((child, i) => {
        if (!React.isValidElement(child)) return child;
        return React.cloneElement(child, { delay: baseDelay + i * step, key: child.key ?? i });
      })}
    </div>
  );
};
